import SwiperCore, { Autoplay, Navigation, Pagination, EffectFade, Thumbs, Lazy } from 'swiper/core';
const Swiper = SwiperCore.use([Autoplay, Navigation, Pagination, EffectFade, Thumbs, Lazy]);

export default {
  init() {
    // JavaScript to be fired on the home page
    const className = 'is-active';
    const sectInquiry = document.querySelector('#sectInquiry');
    const btnSectInquiryOpen = document.querySelector('#btnSectInquiryOpen');
    const btnSectInquiryClose = document.querySelector('#btnSectInquiryClose');
    if(sectInquiry) {
      if(btnSectInquiryOpen) {
        btnSectInquiryOpen.addEventListener('click', () => {
          sectInquiry.classList.add(className);
        });
      }
      if(btnSectInquiryClose) {
        btnSectInquiryClose.addEventListener('click', () => {
          sectInquiry.classList.remove(className);
        });
      }
    }

    let pastSlide;
    const thumbSwiper = new Swiper('#top-mv-thumb-swiper', {
      spaceBetween: 10,
      slidesPerColumnFill: 'row',
      slidesPerView: 3,
      slidesPerColumn: 4,
      slidesPerGroup: 12,
      freeMode: true,
      mousewheel: false,
    });
    new Swiper('#top-mv-swiper', {
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.sect-mv__swiper-button-next',
        prevEl: '.sect-mv__swiper-button-prev',
      },
      pagination: {
        el: '.sect-mv__swiper-pagination',
        type: 'bullets',
      },
      speed: 1000,
      effect: 'fade',
      thumbs: {
        swiper: thumbSwiper,
      },
      mousewheel: false,
      lazy: {
        loadPrevNext: true,
      },
      on: {
        slideChange: function() {
          const previousIndex = this.previousIndex;
          const previousSlide = this.slides[previousIndex];

          const activeIndex = this.activeIndex;
          const activeSlide = this.slides[activeIndex];

          if(activeSlide === pastSlide) {
            pastSlide = null;
          } else {
            activeSlide.classList.add('swiper-custom-animation');
          }
          if(previousSlide) {
            previousSlide.classList.add('swiper-custom-animation');
          }
          if(pastSlide) {
            pastSlide.classList.remove('swiper-custom-animation');
          }
          pastSlide = previousSlide;
        },
      },
    });

    new Swiper('#news-list-swiper', {
      spaceBetween: 20,
      slidesPerView: 1,
      navigation: {
        nextEl: '.sect-newslist__swiper-button-next',
        prevEl: '.sect-newslist__swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      breakpoints: {
        960: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
      },
    })

    /**
     * ブランドエリアの固定背景
     */
    const sectBrand = document.querySelector('.sect-brand');
    const sectBrandBgs = document.querySelectorAll('.sect-brand__bg');
    const sectBrandBgFunc = function() {
      sectBrandBgs.forEach(elem => {
        // elem.style.transform = 'translate3d(0,"'+window.pageYOffset+'px", 0);';
        elem.style.transform = 'translate3d(0,'+window.pageYOffset+'px,0)';
        console.log(window.pageYOffset,elem.clientHeight, elem.style.transform);
      })
    };
    if(sectBrand && sectBrandBgs.length) {
      const isobOptions = {
        rootMargin: window.innerHeight + 'px',
        threshold: 0,
      }
      const isobSectBrand = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            console.log(entry.isIntersecting, entry.intersectionRatio);
            if(entry.isIntersecting) {
              console.log('add');
              window.addEventListener('scroll', sectBrandBgFunc);
            } else {
              console.log('remove');
              window.removeEventListener('scroll', sectBrandBgFunc);
            }
          })
        }
        ,isobOptions
      );
      isobSectBrand.observe(sectBrand);
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/home.js